import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index";
import CalonAnggota from "../views/CalonAnggota.vue";
import Nakes from "../views/NakesList.vue";
import Karyawan from "../views/KaryawanList.vue";
import DokterTelemedicine from "../views/DokterTelemedicine.vue";
import Dashboard from "../views/DashboardAdmin.vue";
import EKatalog from "../views/EKatalog.vue";
import Kegiatan from "../views/KegiatanList.vue";
import KegiatanAdd from "../views/KegiatanAdd.vue";
import KegiatanEdit from "../views/KegiatanEdit.vue";
import Report from "../views/report/ReportUser.vue";
import AgendaPelatihan from "../views/webcontent/AgendaPelatihanNew.vue";
import Mutasi from "../views/Mutasi.vue";
import AkunSatuSehat from "../views/AkunSatuSehat.vue";
import Pasien from "../views/PasienList.vue";
import NakesAdd from "../views/NakesAdd.vue";
import KaryawanAdd from "../views/KaryawanAdd.vue";
import NakesEdit from "../views/NakesEdit.vue";
import KaryawanEdit from "../views/KaryawanEdit.vue";
import PasienEdit from "../views/PasienEdit.vue";
import User from "../views/UserList.vue";
import UserAdd from "../views/UserAdd.vue";
import UserEdit from "../views/UserEdit.vue";
import PrivacyPolicy from "../views/PrivacyPolicy.vue";
import Login from "../views/LoginUser.vue";
import Profesi from "../views/ProfesiList.vue";
import RoleList from "../views/master/RoleList.vue";
import HargaMembershipLMS from "../views/HargaMembershipLMS.vue";
import Faskes from "../views/FaskesList.vue";
import FaskesNakes from "../views/FaskesNakes.vue";
import FaskesCategory from "../views/FaskesCategory.vue";
import Chats from "../views/ChatsMaster.vue";
import ChatsList from "../views/ChatsList.vue";
import TentangKami from "../views/TentangKami.vue";
import KontakKami from "../views/KontakKami.vue";
import SyaratKetentuan from "../views/SyaratKetentuan.vue";
import Privacy from "../views/PrivacyValue.vue";
import Bantuan from "../views/BantuanList.vue";
import Layanan from "../views/LayananList.vue";
import Spesialisasi from "../views/SpesialisasiList.vue";
import Wilayah from "../views/WilayahList.vue";
import Kabupaten from "../views/KabupatenList.vue";
import Pers from "../views/PersList.vue";
import PersAdd from "../views/PersAdd.vue";
import PersEdit from "../views/PersEdit.vue";
import Bank from "../views/BankList.vue";
import RumahSakit from "../views/master/RumahSakit.vue";
import KlinikEksekutif from "../views/master/KlinikEksekutif.vue";
import HomeCare from "../views/master/HomeCare.vue";
import McuList from "../views/master/McuList.vue";
import Obat from "../views/master/MasterObat.vue";
import SupplierObat from "../views/master/SupplierObat.vue";
import KategoriObat from "../views/master/KategoriObat.vue";
import SatuanUnitObat from "../views/master/SatuanUnitObat.vue";
import AdminList from "../views/AdminList.vue";
import AdminInfokomList from "../views/AdminInfokom.vue";
import AdminDPDList from "../views/AdminDPDList.vue";
import AdminDPWList from "../views/AdminDPWList.vue";
import KomisariatList from "../views/KomisariatList.vue";
import DPWList from "../views/DPWList.vue";
import DPDList from "../views/DPDList.vue";
import PaketMembership from "../views/PaketMembership.vue";
import PaketMembershipUser from "../views/PaketMembershipUser.vue";
import TipePaketMembership from "../views/TipePaketMembership.vue";
import EvaluasiFasilitator from "../views/EvaluasiFasilitator.vue";
import PsikologisDisc from "../views/psikologis/PsikologisDisc.vue";
import PsikologisLoyalitas from "../views/psikologis/PsikologisLoyalitas.vue";

import PibBroadcast from "../views/PibBroadcast.vue";
import HistoryChats from "../views/HistoryChats.vue";
import HistoryChatDetail from "../views/HistoryChatDetail.vue";

import JadwalPraktekDokter from "../views/JadwalPraktekDokter.vue";
import JadwalKonsultasi from "../views/JadwalKonsultasi.vue";

//web content
import BrosurList from "../views/webcontent/BrosurList.vue";
import JadwalPelatihanList from "../views/webcontent/JadwalPelatihanList.vue";
import Jabatan from "../views/master/JabatanMaster.vue";
import Direksi from "../views/webcontent/DireksiList.vue";
import KarirList from "../views/webcontent/KarirList.vue";
import Artikel from "../views/webcontent/ArtikelList.vue";
import ArtikelAdd from "../views/webcontent/ArtikelAdd.vue";
import ArtikelEdit from "../views/webcontent/ArtikelEdit.vue";
import KategoriArtikel from "../views/webcontent/KategoriArtikel.vue";
import Berita from "../views/webcontent/BeritaList.vue";
import BeritaAdd from "../views/webcontent/BeritaAdd.vue";
import BeritaEdit from "../views/webcontent/BeritaEdit.vue";
import KategoriBerita from "../views/webcontent/KategoriBerita.vue";
import TestimoniAdd from "../views/webcontent/TestimoniAdd.vue";
import TestimoniEdit from "../views/webcontent/TestimoniEdit.vue";
import Testimoni from "../views/webcontent/TestimoniList.vue";
import Fasilitas from "../views/webcontent/FasilitasList.vue";
import Fasilitator from "../views/webcontent/FasilitatorList.vue";
import StrukturOrganisasi from "../views/webcontent/StrukturOrganisasiNew.vue";
import SummaryLayanan from "../views/webcontent/SummaryLayanan.vue";
import SettingRS from "../views/webcontent/SettingRS.vue";
import HubungiKami from "../views/webcontent/HubungiKami.vue";
import VisiMisi from "../views/webcontent/VisiMisiNew.vue";
import Sejarah from "../views/webcontent/SejarahMaster.vue";

import Timeline from "../views/TimelineList.vue";
import Poli from "../views/master/PoliList.vue";
import LayananSuperior from "../views/master/LayananSuperior.vue";
import PartnershipMaster from "../views/master/PartnershipMaster.vue";
import Komunitas from "../views/KomunitasList.vue";
import KeuanganAnggota from "../views/KeuanganAnggota.vue";
import SettingTelemedicine from "../views/SettingTelemedicine.vue";
import TermAndCondition from "../views/telemedicine/TermAndCondition.vue";
import UserList from "../views/UserList.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    props: true,
    component: Login,
    meta: {
      isHome: 0,
    },
  },
  {
    path: "/privacypolicy",
    name: "PrivacyPolicy",
    props: true,
    component: PrivacyPolicy,
    meta: {
      isHome: 0,
    },
  },
  {
    path: "/pers",
    name: "Pers",
    props: true,
    component: Pers,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/pers-add",
    name: "PersAdd",
    props: true,
    component: PersAdd,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/pers-edit/:id",
    name: "PersEdit",
    props: true,
    component: PersEdit,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/calon-anggota",
    name: "CalonAnggota",
    props: true,
    component: CalonAnggota,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/nakes",
    name: "Nakes",
    props: true,
    component: Nakes,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/karyawan",
    name: "Karyawan",
    props: true,
    component: Karyawan,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/akun-satu-sehat",
    name: "AkunSatuSehat",
    props: true,
    component: AkunSatuSehat,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/nakes-add",
    name: "NakesAdd",
    props: true,
    component: NakesAdd,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/karyawan-add",
    name: "KaryawanAdd",
    props: true,
    component: KaryawanAdd,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/nakes-edit/:id",
    name: "NakesEdit",
    props: true,
    component: NakesEdit,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/karyawan-edit/:id",
    name: "KaryawanEdit",
    props: true,
    component: KaryawanEdit,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/keuangan",
    name: "KeuanganAnggota",
    props: true,
    component: KeuanganAnggota,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    props: true,
    component: Dashboard,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/e-katalog",
    name: "E-Katalog",
    props: true,
    component: EKatalog,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/kegiatan",
    name: "Kegiatan",
    props: true,
    component: Kegiatan,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/kegiatan-add",
    name: "KegiatanAdd",
    props: true,
    component: KegiatanAdd,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/kegiatan-edit/:id",
    name: "KegiatanEdit",
    props: true,
    component: KegiatanEdit,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/report/kegiatan/:kegiatanId/user/:id",
    name: "report",
    props: true,
    component: Report,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/user",
    name: "User",
    props: true,
    component: User,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/user-add",
    name: "UserAdd",
    props: true,
    component: UserAdd,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/user-edit/:id",
    name: "UserEdit",
    props: true,
    component: UserEdit,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/profesi",
    name: "Profesi",
    props: true,
    component: Profesi,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/role",
    name: "Role",
    props: true,
    component: RoleList,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/user",
    name: "User",
    props: true,
    component: UserList,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/harga-membership",
    name: "HargaMembershipLMS",
    props: true,
    component: HargaMembershipLMS,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/wilayah",
    name: "Wilayah",
    props: true,
    component: Wilayah,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/kabupaten/:id",
    name: "Kabupaten",
    props: true,
    component: Kabupaten,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/spesialisasi",
    name: "Spesialisasi",
    props: true,
    component: Spesialisasi,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/bank",
    name: "Bank",
    props: true,
    component: Bank,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/rumah-sakit",
    name: "RumahSakit",
    props: true,
    component: RumahSakit,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/klinik-eksekutif",
    name: "KlinikEksekutif",
    props: true,
    component: KlinikEksekutif,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/home-care",
    name: "HomeCare",
    props: true,
    component: HomeCare,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/mcu",
    name: "McuList",
    props: true,
    component: McuList,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/obat",
    name: "Obat",
    props: true,
    component: Obat,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/supplier",
    name: "SupplierObat",
    props: true,
    component: SupplierObat,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/kategori-obat",
    name: "KategoriObat",
    props: true,
    component: KategoriObat,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/satuan-unit-obat",
    name: "SatuanUnitObat",
    props: true,
    component: SatuanUnitObat,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/admin",
    name: "AdminList",
    props: true,
    component: AdminList,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/admininfokom",
    name: "AdminInfokomList",
    props: true,
    component: AdminInfokomList,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/admindpd",
    name: "AdminDPDList",
    props: true,
    component: AdminDPDList,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/admindpw",
    name: "AdminDPWList",
    props: true,
    component: AdminDPWList,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/komisariat",
    name: "KomisariatList",
    props: true,
    component: KomisariatList,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/dpw",
    name: "DPWList",
    props: true,
    component: DPWList,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/dpd",
    name: "DPDList",
    props: true,
    component: DPDList,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/mutasi",
    name: "Mutasi",
    props: true,
    component: Mutasi,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/paket-membership",
    name: "PaketMembership",
    props: true,
    component: PaketMembership,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/paket-membership-user",
    name: "PaketMembershipUser",
    props: true,
    component: PaketMembershipUser,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/tipe-paket-membership",
    name: "TipePaketMembership",
    props: true,
    component: TipePaketMembership,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/evaluasi-fasilitator",
    name: "Evaluasi Fasilitator",
    props: true,
    component: EvaluasiFasilitator,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/psikologis/disc",
    name: "PsikologisDisc",
    props: true,
    component: PsikologisDisc,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/psikologis/loyalitas",
    name: "PsikologisLoyalitas",
    props: true,
    component: PsikologisLoyalitas,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/layanan",
    name: "Layanan",
    props: true,
    component: Layanan,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/faskes",
    name: "Faskes",
    props: true,
    component: Faskes,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/faskes/nakes/:id",
    name: "FaskesNakes",
    props: true,
    component: FaskesNakes,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/faskes-category",
    name: "FaskesCategory",
    props: true,
    component: FaskesCategory,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/tentang-kami",
    name: "TentangKami",
    props: true,
    component: TentangKami,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/kontak-kami",
    name: "KontakKami",
    props: true,
    component: KontakKami,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/syarat-ketentuan",
    name: "SyaratKetentuan",
    props: true,
    component: SyaratKetentuan,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/bantuan",
    name: "Bantuan",
    props: true,
    component: Bantuan,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/privacy",
    name: "Privacy",
    props: true,
    component: Privacy,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/chats",
    name: "Chats",
    props: true,
    component: Chats,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/chats/list/:nakes_id/:patient_id",
    name: "ChatsList",
    props: true,
    component: ChatsList,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/webcontent/brosurlist",
    name: "BrosurList",
    props: true,
    component: BrosurList,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/webcontent/jadwalpelatihanlist",
    name: "JadwalPelatihanList",
    props: true,
    component: JadwalPelatihanList,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/webcontent/agenda-pelatihan",
    name: "AgendaPelatihan",
    props: true,
    component: AgendaPelatihan,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/master/jabatanlist",
    name: "JabatanList",
    props: true,
    component: Jabatan,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/webcontent/pengurus",
    name: "DireksiList",
    props: true,
    component: Direksi,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/webcontent/karir",
    name: "KarirList",
    props: true,
    component: KarirList,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/webcontent/artikel",
    name: "ArtikelList",
    props: true,
    component: Artikel,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/webcontent/artikel/add",
    name: "ArtikelAdd",
    props: true,
    component: ArtikelAdd,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/webcontent/artikel/edit/:id",
    name: "ArtikelEdit",
    props: true,
    component: ArtikelEdit,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/webcontent/kategori-artikel",
    name: "KategoriArtikel",
    props: true,
    component: KategoriArtikel,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/webcontent/berita",
    name: "BeritaList",
    props: true,
    component: Berita,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/webcontent/berita/add",
    name: "BeritaAdd",
    props: true,
    component: BeritaAdd,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/webcontent/berita/edit/:id",
    name: "BeritaEdit",
    props: true,
    component: BeritaEdit,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/webcontent/testimoni/add",
    name: "TestimoniAdd",
    props: true,
    component: TestimoniAdd,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/webcontent/testimoni/edit/:id",
    name: "TestimoniEdit",
    props: true,
    component: TestimoniEdit,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/webcontent/testimoni",
    name: "TestimoniList",
    props: true,
    component: Testimoni,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/webcontent/fasilitas",
    name: "FasilitasList",
    props: true,
    component: Fasilitas,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/webcontent/fasilitator",
    name: "FasilitatorList",
    props: true,
    component: Fasilitator,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/webcontent/struktur-organisasi",
    name: "StrukturOrganisasi",
    props: true,
    component: StrukturOrganisasi,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/webcontent/kategori-berita",
    name: "KategoriBerita",
    props: true,
    component: KategoriBerita,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/webcontent/summary-layanan",
    name: "SummaryLayanan",
    props: true,
    component: SummaryLayanan,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/webcontent/setting-rs",
    name: "SettingRS",
    props: true,
    component: SettingRS,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/webcontent/visi-misi",
    name: "VisiMisi",
    props: true,
    component: VisiMisi,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/webcontent/hubungi-kami",
    name: "HubungiKami",
    props: true,
    component: HubungiKami,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/webcontent/sejarah",
    name: "Sejarah",
    props: true,
    component: Sejarah,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/timeline",
    name: "Timeline",
    props: true,
    component: Timeline,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/poli",
    name: "Poli",
    props: true,
    component: Poli,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/komunitas",
    name: "Komunitas",
    props: true,
    component: Komunitas,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/informasi-broadcast",
    name: "PibBroadcast",
    props: true,
    component: PibBroadcast,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/jadwal-praktek-dokter",
    name: "JadwalPraktekDokter",
    props: true,
    component: JadwalPraktekDokter,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/jadwal-konsultasi",
    name: "JadwalKonsultasi",
    props: true,
    component: JadwalKonsultasi,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/dokter-telemedicine",
    name: "DokterTelemedicine",
    props: true,
    component: DokterTelemedicine,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/history-chats",
    name: "HistoryChats",
    props: true,
    component: HistoryChats,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/pasien",
    name: "Pasien",
    props: true,
    component: Pasien,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/pasien-edit/:id",
    name: "PasienEdit",
    props: true,
    component: PasienEdit,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/setting-telemedicine",
    name: "SettingTelemedicine",
    props: true,
    component: SettingTelemedicine,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/term-and-condition-telemedicine",
    name: "TermAndConditionTelemedicine",
    props: true,
    component: TermAndCondition,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/history-chats/detail/:id",
    name: "HistoryChatDetail",
    props: true,
    component: HistoryChatDetail,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/master-layanan-superior",
    name: "LayananSuperior",
    props: true,
    component: LayananSuperior,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
  {
    path: "/master-partnership",
    name: "PartnershipMaster",
    props: true,
    component: PartnershipMaster,
    meta: {
      isHome: 1,
      requiresAuth: true,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next();
      return;
    }
    next("/");
  } else {
    next();
  }
});

export default router;
